import StraightLine from './line-straight-1';
import BentLine2 from './line-bent/line-bent-2';
import BentLine3 from './line-bent/line-bent-3';
import BentLine4 from './line-bent/line-bent-4';
import BentLine5 from './line-bent/line-bent-5';
import CurvedLine2 from './line-curved/line-curved-2';
import CurvedLine3 from './line-curved/line-curved-3';
import CurvedLine4 from './line-curved/line-curved-4';
import CurvedLine5 from './line-curved/line-curved-5';
import CustomLine from './line-custom';
import expect from '@src/slide/infrastructure/module/independent/assert/expect';
import { LineShapeType } from '../shape-info/graphic-type';

export {
    StraightLine,
    BentLine2,
    BentLine3,
    BentLine4,
    BentLine5,
};

export const LineType = {
    NONE: 'none',
    LINE: 'line',
    STRAIGNTCONNECTOR1: 'straightConnector1',
    BENTCONNECTOR1: 'bentConnector1',
    BENTCONNECTOR2: 'bentConnector2',
    BENTCONNECTOR3: 'bentConnector3',
    BENTCONNECTOR4: 'bentConnector4',
    BENTCONNECTOR5: 'bentConnector5',
    CURVEDCONNECTOR2: 'curvedConnector2',
    CURVEDCONNECTOR3: 'curvedConnector3',
    CURVEDCONNECTOR4: 'curvedConnector4',
    CURVEDCONNECTOR5: 'curvedConnector5',
    CUSTOM: 'custom',
};

/**
 * @return {string}
 */
export function lineTypeOfInsertShapeType(insertLineShapeType: string): string {
    switch (insertLineShapeType) {
        case LineShapeType.NoHeadStraight:
        case LineShapeType.OneEndArrowStraight:
        case LineShapeType.TwoEndArrowStraight:
            return LineType.STRAIGNTCONNECTOR1;
        case LineShapeType.NoHeadBent:
        case LineShapeType.OneEndArrowBent:
        case LineShapeType.TwoEndArrowBent:
            return LineType.BENTCONNECTOR3;
        case LineShapeType.NoHeadCurved:
        case LineShapeType.OneEndArrowCurved:
        case LineShapeType.TwoEndArrowCurved:
            return LineType.CURVEDCONNECTOR3;
        default:
            return LineType.NONE;
    }
}

export function headEndInfoOfInsertLineType(insertLineShapeType: string): string | null {
    if (insertLineShapeType === LineShapeType.TwoEndArrowStraight
        || insertLineShapeType === LineShapeType.TwoEndArrowBent
        || insertLineShapeType === LineShapeType.TwoEndArrowCurved) {
        return 'triangle';
    }
    return null;
}

export function tailEndInfoOfInsertLineType(insertLineShapeType: string): string | null {
    if (insertLineShapeType === LineShapeType.OneEndArrowStraight
        || insertLineShapeType === LineShapeType.TwoEndArrowStraight
        || insertLineShapeType === LineShapeType.OneEndArrowBent
        || insertLineShapeType === LineShapeType.TwoEndArrowBent
        || insertLineShapeType === LineShapeType.OneEndArrowCurved
        || insertLineShapeType === LineShapeType.TwoEndArrowCurved) {
        return 'triangle';
    }
    return null;
}

// eslint-disable-next-line max-len
type LineConstructor = typeof StraightLine | typeof BentLine2 | typeof BentLine3 | typeof BentLine4 | typeof BentLine5 | typeof CurvedLine2 | typeof CurvedLine3 | typeof CurvedLine4 | typeof CurvedLine5 | typeof CustomLine;

// eslint-disable-next-line max-len
export type LineClass = StraightLine | BentLine2 | BentLine3 | BentLine4 | BentLine5 | CurvedLine2 | CurvedLine3 | CurvedLine4 | CurvedLine5 | CustomLine;
// eslint-disable-next-line complexity
export function bgLineOfType(type: string | null): LineConstructor | null {
    switch (type) {
        case LineType.LINE:
        case LineType.STRAIGNTCONNECTOR1:
            return StraightLine;
        case LineType.BENTCONNECTOR2:
            return BentLine2;
        case LineType.BENTCONNECTOR3:
            return BentLine3;
        case LineType.BENTCONNECTOR4:
            return BentLine4;
        case LineType.BENTCONNECTOR5:
            return BentLine5;
        case LineType.CURVEDCONNECTOR2:
            return CurvedLine2;
        case LineType.CURVEDCONNECTOR3:
            return CurvedLine3;
        case LineType.CURVEDCONNECTOR4:
            return CurvedLine4;
        case LineType.CURVEDCONNECTOR5:
            return CurvedLine5;
        case LineType.NONE:
        case LineType.CUSTOM:
            return CustomLine;

        default:
            return null;
    }
}

export function lineTypeOnMovingStartEnd(type: string): string {
    if (expect(type).isString() && type.startsWith('bentConnector')) {
        return LineType.BENTCONNECTOR3;
    }
    if (expect(type).isString() && type.startsWith('curvedConnector')) {
        return LineType.CURVEDCONNECTOR3;
    }
    return type;
}

// eslint-disable-next-line complexity
export function lineTypeByCornerNum(num: number, originType: string): string {
    if (expect(originType).isString() && originType.startsWith('bentConnector')) {
        if (num === 3) return LineType.BENTCONNECTOR2;
        if (num === 4) return LineType.BENTCONNECTOR3;
        if (num === 5) return LineType.BENTCONNECTOR4;
        if (num === 6) return LineType.BENTCONNECTOR5;
    }
    if (expect(originType).isString() && originType.startsWith('curvedConnector')) {
        if (num === 3) return LineType.CURVEDCONNECTOR2;
        if (num === 4) return LineType.CURVEDCONNECTOR3;
        if (num === 5) return LineType.CURVEDCONNECTOR4;
        if (num === 6) return LineType.CURVEDCONNECTOR5;
    }
    return originType;
}
